import {
    PostAPI,
    PostAPIWithoutRequest,
    PostAPIWithoutRequestAndKeyData,
  } from "src/components/api/helper/apiHelper";

  export const Insert = async (request: string) => {
    return PostAPI(request, "CartMaster/Insert");
  };

  export const Select = async () =>{
    return PostAPIWithoutRequest("CartMaster/Select");
  };

  export const Delete = async (request: string) => {
    return PostAPI(request, "CartMaster/Delete");
  };

  export const Update = async (request: string) => {
    return PostAPI(request, "CartMaster/Update");
  };

  export const SelectByID = async (request: string) => {
    return PostAPI(request, "CartMaster/SelectByID");
  };
  
  export const DeleteCartMultipleProduct = async (request: string) => {
    return PostAPI(request, "CartMaster/DeleteCartMultipleProduct");
  };